import { render, staticRenderFns } from "./widgetTable.vue?vue&type=template&id=64bfaada&scoped=true&"
import script from "./widgetTable.vue?vue&type=script&lang=js&"
export * from "./widgetTable.vue?vue&type=script&lang=js&"
import style0 from "./widgetTable.vue?vue&type=style&index=0&id=64bfaada&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfaada",
  null
  
)

export default component.exports